import { Button } from 'components/atoms';
import DigitalDeliveryCountryPopup from 'components/molecules/popup/digital-delivery-country/DigitalDeliveryCountryPopup';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine, PiTrash } from 'react-icons/pi';
import { PopupActions } from 'reactjs-popup/dist/types';
import {
  AsapType,
  IDigitalDeliveryBase,
} from 'services/digital-delivery/types';
import './DeliveryCountryCard.scss';

interface IDeliveryCountryCardProps {
  country: IDigitalDeliveryBase;
  type: 'included' | 'excluded';
  onRemove: () => void;
  onSave: (country: IDigitalDeliveryBase, actions?: PopupActions) => void;
}

const DeliveryCountryCard = ({
  country,
  onRemove,
  type,
  onSave,
}: IDeliveryCountryCardProps) => {
  const { t } = useTranslation();
  return (
    <div className='delivery-country-card'>
      <img
        src={`https://flagsapi.com/${country.countryCode}/flat/32.png`}
        className='min-w-[32px] rounded'
      />
      <div className='delivery-country-card-name'>
        <p className='delivery-country-card-header'>
          {t(`countries.${country.countryCode}`)}
        </p>
        <p>
          {country.asap !== AsapType.None
            ? t(`enum.AsapType.${AsapType[country.asap]}`)
            : `${country.publishDate} ${country.publishTime}`}
        </p>
      </div>
      <DigitalDeliveryCountryPopup
        initialCountry={country}
        onSave={onSave}
        type={type}
        trigger={
          <Button onlyIcon isClear size='compact'>
            <Button.Icon icon={<PiPencilSimpleLine />} />
          </Button>
        }
      />
      <Button
        onlyIcon
        isClear
        size='compact'
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onRemove();
        }}>
        <Button.Icon icon={<PiTrash />} />
      </Button>
    </div>
  );
};

export default DeliveryCountryCard;
